import { render } from "./Show.vue?vue&type=template&id=0c8b3423"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"
script.render = render

export default script